import { NgModule } from '@angular/core';
import { NamedRouterOutletDirective } from './named-router-outlet.directive';

@NgModule({
  imports: [NamedRouterOutletDirective],
  exports: [NamedRouterOutletDirective],
})
export class NamedRouterOutletModule {}
